import './Footer.css';

export function Footer() {
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__copy">© 2026 Vivek Yellanti</div>
        <div className="footer__hint">
          Austin, TX · Building event-driven systems · Open to founder work
        </div>
      </div>
    </footer>
  );
}
